import {type Page, type Pageable, toUrlParams} from "../util/pageable";
import type {Session} from "../entities/Session";
import {myAxios} from "../util/myAxios";
import {eventUrl} from './base';

export function getSessions(
  pageable: Pageable
): Promise<Page<Session>> {
  return myAxios()
    .then(axios => axios.get(eventUrl(`/sessions?`) + toUrlParams(pageable)))
    .then(response => response.data);
}

export function getAllSessionsOfToday(
): Promise<Session[]> {
  return myAxios()
    .then(axios => axios.get(eventUrl(`/sessions/today`)))
    .then(response => response.data);
}
